module.exports = __webpack_public_path__ + "static/media/gulp.7582d2f7.svg";